var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-bg"}),_c('div',{staticClass:"loading-msg"},[_c('div',{attrs:{"id":"block_ui","align":"center"}},[_c('img',{attrs:{"src":"/images/plugins/bx_loader.gif"}})])])])
}]

export { render, staticRenderFns }